
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-1817ed1d&scoped=true!../../../vue-loader/lib/selector?type=styles&index=0!./SvgIcon.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./SvgIcon.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-1817ed1d!../../../vue-loader/lib/selector?type=template&index=0!./SvgIcon.vue"),
  /* scopeId */
  "data-v-1817ed1d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/components/SvgIcon.vue
// module id = 673
// module chunks = 94